import React, { useEffect, useState, useContext } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

import TrialBanner from "./Components/TrialBanner.js";
import Alert from "./Components/Alerts/Alert";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import HomeNav from "./Components/Navbars/HomeNav";
import ServiceNavBar from "./Components/Navbars/ServiceNavBar.js";
import UserNav from "./Components/Navbars/UserNav";
import Footer from "./Components/Footer/Footer";

import Slider from "./Components/BlogSlider/Slider";
import CheckOutForm from "./Components/Services/CheckOutForm.jsx";
import NewService from "./Components/Services/NewService.jsx";
import CategoryGrid from "./Components/Services/IconMenu.jsx";
import ConfirmWindow from "./Components/Services/ConfirmWindow.jsx";

import LoadingScreen from "./Page_Components/Home/LoadingScreen/LoadingScreen";
import Intro from "./Page_Components/Home/Introduction/Intro";
import HeroImg from "./Page_Components/Home/HeroSections/HeroImg";
import Products from "./Page_Components/Home/HeroSections/Products";
import OurWork from "./Page_Components/Home/HeroSections/OurWork.js";
import About from "./Page_Components/Home/About/About";
import JuridentPayment from "./Page_Components/JuridentPayment/JuridentPayment";
import JuridentSuccess from "./Page_Components/JuridentPayment/JuridentSuccess";
import JuridentFailure from "./Page_Components/JuridentPayment/JuridentFailure";

import BlogPageBody from "./Page_Components/BlogPage/BlogPage";
import ReadBlogsBody from "./Page_Components/ReadBlog/ReadBlog";
import CreateBlogBody from "./Page_Components/CreateBlog/CreateBlog";
import MyBlogs from "./Page_Components/MyBlogs/MyBlogsBody.js";
import EditBlog from "./Page_Components/MyBlogs/EditBlog.js";
import ViewBlog from "./Page_Components/MyBlogs/ViewBlog.js";
import { AppProvider } from "./Context/BlogContext.js";

import LoginBody from "./Page_Components/Login/Login";
import AdminLogin from "./Page_Components/Login/AdminLogin.js";
import AdminPortal from "./Page_Components/Login/AdminPortal.js";

import PrivacyPageBody from "./Page_Components/PrivacyPage/Privacy";
import RefundPageBody from "./Page_Components/RefundPage/RefundPage";
import TermsAndConditionPageBody from "./Page_Components/TermsConditionPage/TermsCondition";

import Success from "./Components/Payment_redirect/Success";
import Failure from "./Components/Payment_redirect/Failure";

import ServiceBody from "./Page_Components/ServicePage/MainServicePage/ServiceBody";
import ServicesDisplayBody from "./Page_Components/ServicePage/ServicesDisplayPage/ServicesDisplay";
import CheckFrontend from "./Page_Components/ServicePage/MainServicePage/check_frontend.js";
import CheckBackend from "./Page_Components/ServicePage/MainServicePage/check_backend.js";
import CheckAppdev from "./Page_Components/ServicePage/MainServicePage/check_appdev.js";
import CheckUidev from "./Page_Components/ServicePage/MainServicePage/check_uidev.js";
import RegisterFrontend from "./Page_Components/ServicePage/MainServicePage/register_front.js";
import RegisterBackend from "./Page_Components/ServicePage/MainServicePage/register_back.js";
import RegisterAndroid from "./Page_Components/ServicePage/MainServicePage/register_android.js";
import RegisterUi from "./Page_Components/ServicePage/MainServicePage/register_ui.js";

import { AuthContext } from "./Page_Components/Login/AuthContext.js";
import Career from "./Page_Components/Careers/careers.jsx";

//careers navbar 
import { useLocation } from "react-router-dom";

function HomeScrollHandler({ children }) {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        el?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [location]);

  return children;
}

function App() {
  const { authenticated, setAuthenticated, isAdmin, setIsAdmin } =
    useContext(AuthContext);

  const [isLoadingComplete, setIsLoadingComplete] = useState(false);
  const [alertMsg, setAlertMsg] = useState(
    localStorage.getItem("alertMsg") || ""
  );
  const [alertColor, setAlertColor] = useState(
    localStorage.getItem("alertColor") || ""
  );
  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoadingComplete(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    localStorage.setItem("alertMsg", alertMsg);
    localStorage.setItem("alertColor", alertColor);
  }, [alertMsg, alertColor]);

  // Nav links
  const homeNav = [
    { title: "Products", link: "products", type: "Link" },
    { title: "About Us", link: "about", type: "Link" },
    { title: "Blogs", link: "/BlogHome", type: "NavLink" },
    { title: "Courses", link: "/Courses", type: "NavLink" },
    { title: "Careers", link: "/careers", type: "NavLink" },
    { title: "Services", link: "/Services", type: "NavLink" },
  ];

  const coursesNav = [
     { title: "Products", link: "products", type: "Link" },
    { title: "About Us", link: "about", type: "Link" },
    { title: "Blogs", link: "/BlogHome", type: "NavLink" },
    { title: "Courses", link: "/Courses", type: "NavLink" },
    { title: "Careers", link: "/careers", type: "NavLink" },
    { title: "Services", link: "/Services", type: "NavLink" },
    //{ title: "Home", link: "/", type: "NavLink" },
    // { title: "Blogs", link: "/BlogHome", type: "NavLink" },
    // { title: "Contact Us", link: "contactuspage", type: "Link" },
  ];

  // const serviceNav = [
  //   { title: "Home", link: "/", type: "NavLink" },
  //   { title: "Courses", link: "/Courses", type: "NavLink" },
  //   { title: "Contact Us", link: "contactuspage", type: "Link" },
  //   { title: "Register", link: "/RegisterCourse", type: "NavLink" },
  //   { title: "Services", link: "/Services", type: "NavLink" },
  // ];
  const serviceNav = [
  { title: "Home", link: "/", type: "NavLink" },

  { title: "Products", link: "products", type: "Link" },
  { title: "About Us", link: "about", type: "Link" },

  { title: "Blogs", link: "/BlogHome", type: "NavLink" },
  { title: "Courses", link: "/Courses", type: "NavLink" },
  { title: "Careers", link: "/careers", type: "NavLink" },

  { title: "Services", link: "/Services", type: "NavLink" },
  // { title: "Register", link: "/RegisterCourse", type: "NavLink" },
];

  const policyNav = [
    { title: "Home", link: "/", type: "NavLink" },
    { title: "Blogs", link: "/BlogHome", type: "NavLink" },
    { title: "Courses", link: "/Courses", type: "NavLink" },
  ];

  const serviceNav1 = [
    { title: "Home", link: "/", type: "NavLink" },
    // { title: "Contact Us", link: "contactuspage", type: "Link" },
    { title: "Services", link: "/Services", type: "NavLink" },
  ];

  const linksList = [homeNav, coursesNav, serviceNav, policyNav, serviceNav1];

  // HOC for pages with UserNav + Alerts
  const withUserNav = (Component, extraProps = {}) => {
    return function WrappedComponent(props) {
      return (
        <div className="container">
          <UserNav
            authenticated={authenticated}
            setAuthenticated={setAuthenticated}
            isAdmin={isAdmin}
            setIsAdmin={setIsAdmin}
            alertMsg={alertMsg}
            setAlertMsg={setAlertMsg}
            alertColor={alertColor}
            setAlertColor={setAlertColor}
          />
          <Alert
            alertMsg={alertMsg}
            setAlertMsg={setAlertMsg}
            alertColor={alertColor}
            setAlertColor={setAlertColor}
          />
          <Component
            {...props}
            authenticated={authenticated}
            setAuthenticated={setAuthenticated}
            isAdmin={isAdmin}
            setIsAdmin={setIsAdmin}
            alertMsg={alertMsg}
            setAlertMsg={setAlertMsg}
            alertColor={alertColor}
            setAlertColor={setAlertColor}
            {...extraProps}
          />
        </div>
      );
    };
  };

  return (
    <>
      <AppProvider>
        <ScrollToTop />
        <Routes>
          {/* Home */}
         <Route
  path="/"
  element={
    !isLoadingComplete ? (
      <LoadingScreen />
    ) : (
      <HomeScrollHandler>
        <>
          {showBanner && (
            <TrialBanner onClose={() => setShowBanner(false)} />
          )}
          <HomeNav linksList={linksList[0]} />
          <Intro />
          <HeroImg />
          <Products />
          <OurWork />
          <Slider authenticated={authenticated} />
          <About />
          <Footer />
        </>
      </HomeScrollHandler>
    )
  }
/>


          <Route
            path="/check_frontend"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <CheckFrontend />
                <Footer />
              </>
            }
          />
          <Route
            path="/check_backend"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <CheckBackend />
                <Footer />
              </>
            }
          />
          <Route
            path="/check_appdev"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <CheckAppdev />
                <Footer />
              </>
            }
          />
          <Route
            path="/check_uidev"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <CheckUidev />
                <Footer />
              </>
            }
          />

          {/* Dynamic registration routes */}
          {/* <Route path="/register_:serviceName" element={<RegisterCourse />} /> */}

          {/* Services */}
          <Route
            path="/Services"
            element={
              <>
                <ServiceNavBar
                  linksList={linksList[0]}
                  authenticated={authenticated}
                  setAuthenticated={setAuthenticated}
                  alertMsg={alertMsg}
                  setAlertMsg={setAlertMsg}
                  alertColor={alertColor}
                  setAlertColor={setAlertColor}
                />
                <NewService />
                <div className="translate-y-0 lg:-mt-36">
                  <CategoryGrid />
                </div>
                <Footer />
              </>
            }
          />
          <Route
            path="/Service"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <ServiceBody
                  formVisible={true}
                  authenticated={authenticated}
                  alertMsg={alertMsg}
                  setAlertMsg={setAlertMsg}
                  alertColor={alertColor}
                  setAlertColor={setAlertColor}
                />
                <Footer />
              </>
            }
          />
          <Route
            path="/RegisterCourse"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <ServiceBody
                  formVisible={true}
                  authenticated={authenticated}
                  alertMsg={alertMsg}
                  setAlertMsg={setAlertMsg}
                  alertColor={alertColor}
                  setAlertColor={setAlertColor}
                />
                <Footer />
              </>
            }
          />

          <Route
            path="/Register_front"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <RegisterFrontend />
              </>
            }
          ></Route>
          <Route
            path="/Register_back"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <RegisterBackend />
              </>
            }
          ></Route>
          <Route
            path="/Register_android"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <RegisterAndroid />
              </>
            }
          ></Route>
          <Route
            path="/Register_uiux"
            element={
              <>
                <HomeNav linksList={linksList[2]} />
                <RegisterUi />
              </>
            }
          ></Route>

          {/* Blog Pages */}
          <Route path="/BlogHome" element={withUserNav(ReadBlogsBody)()} />
          <Route path="/CreateBlog" element={withUserNav(CreateBlogBody)()} />
          <Route path="/MyBlogs" element={withUserNav(MyBlogs)()} />
          <Route path="/BlogPage/:ID" element={withUserNav(BlogPageBody)()} />
          <Route
            path="/EditBlog/:blogId"
            element={
              <EditBlog
                setAlertMsg={setAlertMsg}
                setAlertColor={setAlertColor}
              />
            }
          />
          <Route path="/ViewBlog/:blogId" element={<ViewBlog />} />

          {/* Auth */}
          <Route path="/Login" element={withUserNav(LoginBody)()} />
          <Route path="/AdminLogin" element={withUserNav(AdminLogin)()} />
          <Route
            path="/AdminPortal"
            element={
              authenticated && isAdmin ? (
                <AdminPortal />
              ) : (
                <Navigate to="/Login" replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="/BlogHome" replace />} />

          {/* Policies */}
          <Route
            path="/PrivacyPage"
            element={
              <>
                <HomeNav linksList={linksList[3]} />
                <PrivacyPageBody />
              </>
            }
          />
          <Route
            path="/RefundPolicy"
            element={
              <>
                <HomeNav linksList={linksList[3]} />
                <RefundPageBody />
              </>
            }
          />
          <Route
            path="/T&C"
            element={
              <>
                <HomeNav linksList={linksList[3]} />
                <TermsAndConditionPageBody />
              </>
            }
          />

          {/* Payment */}
          <Route path="/success" element={<Success />} />
          <Route path="/failure" element={<Failure />} />
          <Route path="/checkOutForm" element={<CheckOutForm />} />
          <Route path="/confirmWindow" element={<ConfirmWindow />} />

          {/* Jurident iOS Payment Routes */}
          <Route path="/jurident-payment" element={<JuridentPayment />} />
          <Route path="/jurident-payment/success" element={<JuridentSuccess />} />
          <Route path="/jurident-payment/failure" element={<JuridentFailure />} />

          {/* Courses */}
          <Route
            path="/Courses"
            element={
              <>
                <HomeNav linksList={linksList[1]} />
                <ServicesDisplayBody
                  authenticated={authenticated}
                  alertMsg={alertMsg}
                  setAlertMsg={setAlertMsg}
                  alertColor={alertColor}
                  setAlertColor={setAlertColor}
                />
              </>
            }
          />
          <Route
            path="/careers"
            element={
              <>
                <HomeNav linksList={linksList[0]} />
                <Career />
              </>
            }
          />
        </Routes>
      </AppProvider>
    </>
    // <CategoryGrid/>
  );
}

export default App;
